import React, { Component } from "react";
import { Link } from "react-router-dom";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import "./collection2.css";
import { getRelatedItems } from "../../../services";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import icon from "./G-icon.png";
class ProductItemSkeleton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      cartModalopen: false,
      stock: "InStock",
      quantity: 1,
      image: "",
    };
  }

  render() {
    return (
      <div>
        <div className="product-box product-box-homepage-1">
          <div
            className="img-wrapper img-wrapper-homepage-1"
            style={{
              backgroundColor: "white",
              backgroundSize: "130px 130px",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          >
            <Skeleton height={200} />
          </div>
          <div
            className="product-detail"
            style={{ padding: "5px", paddingBottom: "80px", paddingTop: "0px" }}
          >
            <div>
              <h6
                style={{
                  color: "black",
                  fontSize: "90%",
                  fontWeight: "bold",
                  marginTop: 5,
                  textTransform: "capitalize",
                  whiteSpace: "nowrap", // 🚫 No wrapping
                  overflow: "hidden", // ✂️ Hide overflow
                  textOverflow: "ellipsis", // … Show ellipsis if overflow
                  marginRight: 5,
                  textAlign: "left",
                  paddingBottom: 0,
                }}
                className="product-name"
              >
                <Skeleton />
              </h6>

              <h6
                style={{
                  color: "#ff4a4e",
                  fontSize: "100%",
                  fontWeight: "bold",
                  marginTop: 0,
                  textAlign: "left",
                }}
                className="product-price"
              >
                <Skeleton />
                <br />
              </h6>
              <div
                style={{ fontSize: "80%", textAlign: "left" }}
                className="product-name"
              >
                <Skeleton />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                paddingLeft: 5,
                marginTop: 10,
                borderTop: "1px solid gainsboro",
                paddingTop: 5,
              }}
              className="seller-container"
            >
              <div style={{ fontSize: 12, marginTop: 3 }} className="shop-name">
                <Skeleton />
              </div>
              <div
                style={{
                  fontSize: 11,
                  padding: "3px 7px",

                  borderRadius: 4,

                  cursor: "pointer",

                  transition: "all 0.3s ease-in-out",
                }}
                className="view-seller"
              >
                <Skeleton />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null)(ProductItemSkeleton);
